import "../Loading/Loading.css"
export default function Spinner({className} ) {
    return (<div role="status" className="mt-5">
             <div className="spinner"></div>
        <span className="sr-only">Loading...</span>
    </div>)
}
